import { AboutThisProvider } from '../section/about_this_provider';
import { AboutThisPolicy } from '../section/about_this_policy';
import { PolicyExcesses } from '../section/policy_excesses';
import { TermsAndDisclaimers } from '../section/terms_and_disclaimers';
import { VehicleValue } from '../section/vehicle_value';

const ProductSections = {
    aboutTheProvider: {
        label: 'About this provider',
        id: 'about-this-provider',
        component: AboutThisProvider,
        availableOn: ['COMPREHENSIVE', 'TPPD', 'TPFT']
    },
    aboutThePolicy: {
        label: 'About this policy',
        id: 'about-this-policy',
        component: AboutThisPolicy,
        availableOn: ['COMPREHENSIVE', 'TPPD', 'TPFT']
    },
    policyExcesses: {
        label: 'Policy excesses',
        id: 'policy-excesses',
        component: PolicyExcesses,
        availableOn: ['COMPREHENSIVE', 'TPPD', 'TPFT']
    },
    vehicleValue: {
        label: 'Vehicle value',
        id: 'vehicle-value',
        component: VehicleValue,
        availableOn: ['COMPREHENSIVE']
    },
    termsAndDisclaimers: {
        label: 'Terms and disclaimers',
        id: 'terms-and-disclaimers',
        component: TermsAndDisclaimers,
        availableOn: ['COMPREHENSIVE', 'TPPD', 'TPFT']
    }
};

const Sections = [
    {
        label: 'About this provider',
        id: 'about-this-provider',
        href: '#about-this-provider',
        availableOn: ['COMPREHENSIVE', 'TPPD', 'TPFT']
    },
    {
        label: 'About this policy',
        id: 'about-this-policy',
        href: '#about-this-policy',
        availableOn: ['COMPREHENSIVE', 'TPPD', 'TPFT']
    },
    {
        label: 'Policy excesses',
        id: 'policy-excesses',
        href: '#policy-excesses',
        availableOn: ['COMPREHENSIVE', 'TPPD', 'TPFT']
    },
    {
        label: 'Vehicle value',
        id: 'vehicle-value',
        href: '#vehicle-value',
        availableOn: ['COMPREHENSIVE']
    },
    {
        label: 'Terms and disclaimers',
        id: 'terms-and-disclaimers',
        href: '#terms-and-disclaimers',
        availableOn: ['COMPREHENSIVE', 'TPPD', 'TPFT']
    }
];

const getTheFirstSectionId = () => Object.values(ProductSections)[0].id;

// We have a scroll margin top value '50' here, because there is a momentum scrolling effect on the Apple device.
const scrollMargin = 20;

const stickyBarElementId = 'policy-product-sticky-bar';

export { ProductSections, getTheFirstSectionId, scrollMargin, stickyBarElementId, Sections };
